<template>
    <!-- 找回密码页面组件 -->
    <div id="retrieve-psw-container">
        <!-- header 部分 -->
        <portal-header :isShowUser='false'></portal-header>
        <div class="retrieve-form-div"
             v-show="!isRetrive">
            <Tabs value="phone"
                  :animated="false"
                  v-show="!isSuccess"
                  @on-click="toggleTab">
                <TabPane :label="$t('手机找回密码')"
                         name="phone">
                    <Form ref="phoneForm"
                          action="javascript: void(0)"
                          :model="phoneForm"
                          :rules="phoneRules"
                          class="form-container"
                          @keydown.enter="submitForm('phoneForm')">
                        <FormItem v-show="false">
                            <Input v-show="false"
                                   type="text"></Input>
                        </FormItem>
                        <FormItem v-show="false">
                            <Input v-show="false"
                                   type="password"></Input>
                        </FormItem>
                        <FormItem prop="phone">
                            <Input type="tel"
                                   v-model="phoneForm.phone"
                                   :placeholder="$t('请输入手机号')"></Input>
                        </FormItem>
                        <FormItem prop="smsCode">
                            <Input type="text"
                                   v-model="phoneForm.smsCode"
                                   :placeholder="$t('短信验证码')"
                                   style="width: 50%;"></Input>
                            <Button class="code-btn"
                                    @click="getSmsCode"
                                    :disabled="smsDisabled"
                                    style="color:#515a6e;background:#f8f8f9;">{{smsDisabled ? `${smsTime}s`+$t('后重新发送') : $t('获取短信验证码')}}</Button>
                        </FormItem>
                        <FormItem prop="password">
                            <Input type="password"
                                   autocomplete="new-password"
                                   v-model="phoneForm.password"
                                   @copy.native.capture.prevent="handleCopy"
                                   @cut.native.capture.prevent="handleCopy"
                                   :placeholder="$t('登录密码')"></Input>
                        </FormItem>
                        <FormItem prop="passwordCheck"
                                  :style="{'margin-bottom': showValidateMsg ? '44px' : '24px'}">
                            <Input type="password"
                                   v-model="phoneForm.passwordCheck"
                                   @copy.native.capture.prevent="handleCopy"
                                   @cut.native.capture.prevent="handleCopy"
                                   :placeholder="$t('确认密码')"></Input>
                        </FormItem>
                        <FormItem v-if="showValidateMsg"
                                  style="margin: -24px 0 0 0">
                            <p style="color: red; font-size: 12px;">{{validateMsg}}</p>
                        </FormItem>
                        <FormItem>
                            <Button class="submit"
                                    long
                                    :loading="loading"
                                    type="primary"
                                    @click="submitForm('phoneForm')">
                                {{$t('重置密码')}}
                            </Button>
                        </FormItem>
                    </Form>
                </TabPane>
                <TabPane :label="$t('邮箱找回密码')"
                         name="email">
                    <Form ref="emailForm"
                          :model="emailForm"
                          :rules="emailRules"
                          class="form-container"
                          @keydown.enter="submitForm('emailForm')">
                        <FormItem v-show="false">
                            <Input v-show="false"
                                   type="text"></Input>
                        </FormItem>
                        <FormItem v-show="false">
                            <Input v-show="false"
                                   type="password"></Input>
                        </FormItem>
                        <FormItem prop="email">
                            <Input type="email"
                                   :maxlength="80"
                                   v-model="emailForm.email"
                                   :placeholder="$t('请输入邮箱')"></Input>
                        </FormItem>
                        <FormItem prop="emailCode">
                            <Input type="text"
                                   v-model="emailForm.emailCode"
                                   style="width: 50%"
                                   :placeholder="$t('邮箱验证码')"></Input>
                            <Button class="code-btn"
                                    @click="getEmailCode"
                                    :disabled="emailDisabled"
                                    style="color:#515a6e;background:#f8f8f9;">{{emailDisabled ? `${emailTime}s`+$t('后重新发送') : $t('获取邮箱验证码')}}</Button>
                        </FormItem>
                        <FormItem prop="password">
                            <Input type="password"
                                   autocomplete="new-password"
                                   v-model="emailForm.password"
                                   @copy.native.capture.prevent="handleCopy"
                                   @cut.native.capture.prevent="handleCopy"
                                   :placeholder="$t('登录密码')"></Input>
                        </FormItem>
                        <FormItem prop="passwordCheck"
                                  :style="{'margin-bottom': showValidateMsg ? '44px' : '24px'}">
                            <Input type="password"
                                   v-model="emailForm.passwordCheck"
                                   @copy.native.capture.prevent="handleCopy"
                                   @cut.native.capture.prevent="handleCopy"
                                   :placeholder="$t('确认密码')"></Input>
                        </FormItem>
                        <FormItem v-if="showValidateMsg"
                                  style="margin: -24px 0 0 0">
                            <p style="color: red; font-size: 12px;">{{validateMsg}}</p>
                        </FormItem>
                        <FormItem>
                            <Button class="submit"
                                    long
                                    :loading="loading"
                                    type="primary"
                                    @click="submitForm('emailForm')">
                                {{$t('重置密码')}}
                            </Button>
                        </FormItem>
                    </Form>
                </TabPane>
            </Tabs>
            <div v-show="isSuccess">
                <div class="reser-pwd-formContent">
                    <div class="common-demo passwd1"></div>
                    <p style="color:#59d476; font-size: 14px;">{{$t('密码修改成功')}}</p>
                    <p style="margin-top:22px">
                        <span>{{second}}</span>s{{$t('后自动跳转到主页，')}} {{$t('若未跳转，')}} {{$t('可')}}
                        <span style="color: #1f68b3; cursor: pointer"
                              @click="goLogin">{{$t('点击跳转')}}</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="retrieve-form-div np-retr"
             v-show="isRetrive">
            <h1 class="title-np">{{$t('请联系客服人员获取新密码')}}</h1>
            <h3 class="title-np">{{$t('电话')}}：{{appContactNumber}}</h3>
            <a href="http://p.qiao.baidu.com/cps/chat?siteId=10941574&userId=24199137"
               class="title-np">{{$t('在线咨询')}}</a>
        </div>
        <!-- <div class="footer">
                <span>Copyright © {{$t('佳杰云星')}}</span><span>粤ICP备17031727号-2</span>
            </div> -->
        <div class="footer">
            <span>{{companyname}}</span>&nbsp;&nbsp;<span>{{copyright}}</span>
        </div>
    </div>
</template>
<script>
import portalHeader from '@c/portal/header'
import API from '@/service/api.js'
export default {
    name: 'retrievePasswd',
    components: {
        portalHeader
    },
    data () {
        const validatePassPhone = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('请输入密码')))
            } else {
                if (this.phoneForm.passwordCheck !== '') {
                    // 对第二个密码框单独验证
                    this.$refs.phoneForm.validateField('passwordCheck')
                }
                callback()
            }
        }
        const validatePassCheckPhone = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('请再次输入密码')))
            } else {
                if (value !== this.phoneForm.password) {
                    callback(new Error(this.$t('两次密码输入不一致')))
                } else {
                    callback()
                }
            }
        }
        const validatePassEmail = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('请输入密码')))
            } else {
                if (this.emailForm.passwordCheck !== '') {
                    // 对第二个密码框单独验证
                    this.$refs.emailForm.validateField('passwordCheck')
                }
                callback()
            }
        }
        const validatePassCheckEmail = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('请再次输入密码')))
            } else {
                if (value !== this.emailForm.password) {
                    callback(new Error(this.$t('两次密码输入不一致')))
                } else {
                    callback()
                }
            }
        }
        return {
            companyContactNumber: null,
            companyname: null,
            copyright: null,
            loading: false,
            isRetrive: false,
            emailMsg: '',
            smsDisabled: false,
            emailDisabled: false,
            smsTime: 60,
            emailTime: 180,
            second: 3,
            isSuccess: false,
            phoneForm: {
                phone: '',
                smsCode: '',
                password: '',
                passwordCheck: '',
                smsCodeCopy: '',
                passwordCopy: ''
            },
            emailForm: {
                email: '',
                emailCode: '',
                password: '',
                passwordCheck: ''
            },
            phoneRules: {
                phone: [
                    {
                        required: true,
                        message: this.$t('手机号码不能为空'),
                        trigger: 'blur'
                    },
                    {
                        validator: this.isPhone,
                        trigger: 'blur'
                    },
                    {
                        trigger: 'submit',
                        validator: async (rule, value, callback) => {
                            const result = await this.uniqueValidate('mobile', this.phoneForm.phone)
                            if (result) {
                                callback(new Error(this.$t('该手机尚未注册')))
                            }
                        }
                    }
                ],
                smsCode: [
                    {
                        required: true,
                        message: this.$t('请输入验证码'),
                        trigger: 'blur'
                    },
                    {
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (value.length > 6) {
                                callback(this.$i18n.t('仅支持6位验证码'))
                            } else {
                                callback()
                            }
                        }
                    }
                ],
                password: [
                    {
                        validator: this.isPassword,
                        trigger: 'blur'
                    },
                    {
                        validator: validatePassPhone,
                        trigger: 'blur'
                    }
                ],
                passwordCheck: [
                    {
                        validator: validatePassCheckPhone,
                        trigger: 'blur'
                    }
                ]
            },
            emailRules: {
                email: [
                    {
                        required: true,
                        message: this.$t('邮箱不能为空'),
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: this.$t('您输入的邮箱格式不正确'),
                        trigger: 'blur'
                    },
                    {
                        trigger: 'submit',
                        validator: async (rule, value, callback) => {
                            const result = await this.uniqueValidate('email', this.emailForm.email)
                            if (result) {
                                callback(new Error(this.$t('该邮箱尚未注册')))
                            }
                        }
                    }
                ],
                emailCode: [
                    {
                        required: true,
                        message: this.$t('请输入验证码'),
                        trigger: 'submit'
                    }
                ],
                password: [
                    {
                        validator: this.isPassword,
                        trigger: 'blur'
                    },
                    {
                        validator: validatePassEmail,
                        trigger: 'blur'
                    }
                ],
                passwordCheck: [
                    {
                        validator: validatePassCheckEmail,
                        trigger: 'blur'
                    }
                ]
            },
            showValidateMsg: false,
            validateMsg: ''
        }
    },
    computed: {
        syslogo () {
            return this.$store.state.app.appConfig.sysLogo
        },
        appContactNumber () { // 系统联系号码
            return this.$store.state.app.appConfig.appContactNumber
        }
    },
    created () {
        this.isShowRetriveFun()
        this.getPortalOem()
    },
    methods: {
        getPortalOem () {
            this.axios.get(this.urlFormat(API.GET_PORTAL_OEM, true), {
                headers: { noAuth: true }
            }).then(res => {
                this.companyname = 'Copyright ©' + res.companyName
                this.copyright = res.preparedNumber || ''
            })
        },
        // 是否拥有找回功能，0表示正常找回，1表示需要联系管理员
        isShowRetriveFun () {
            this.axios.get(this.urlFormat(API.CONFIGS_NONAUTH, true), {
                // params: {
                //     configKey: 'online'
                // },
                headers: {
                    noAuth: true
                }
            }).then((result) => {
                if (result && result.length > 0) {
                    result.forEach(item => {
                        if (item.configKey === 'online') {
                            this.isRetrive = item.configValue === 1 || item.configValue === '1'
                        }
                    })
                }
            })
        },
        toggleTab (name) {
            // if (name === 'phone') {
            //     this.$refs.emailForm.resetFields()
            // } else if (name === 'email') {
            //     this.$refs.phoneForm.resetFields()
            // }
            // if (this.codeTimer) {
            //     clearInterval(this.codeTimer)
            // }
            // this.validateMsg = ''
            // this.showValidateMsg = false
        },
        getSmsCode () {
            const vm = this
            this.$refs.phoneForm.validateField('phone', (valid) => {
                if (!valid) {
                    this.axios.get(this.urlFormat(API.GET_SEND_SMS_CODE, true), {
                        params: {
                            phone: this.phoneForm.phone,
                            captcha: 1,
                            t: 1
                        },
                        headers: {
                            noAuth: true,
                            showMsg: false
                        }
                    }).then((res) => {
                        if (res.status) {
                            this.smsDisabled = true
                            this.codeTimer = setInterval(function () {
                                if (vm.smsTime <= 1) {
                                    vm.smsTime = 60
                                    vm.smsDisabled = false
                                    clearInterval(vm.codeTimer)
                                } else {
                                    vm.smsTime--
                                }
                            }, 1000)
                        }
                    })
                }
            })
        },
        getEmailCode () {
            const vm = this
            this.$refs.emailForm.validateField('email', (valid) => {
                if (!valid) {
                    this.axios.get(this.urlFormat(API.GET_SEND_EMAIL_CODE, true), {
                        params: {
                            email: this.emailForm.email
                        },
                        headers: {
                            noAuth: true
                        }
                    }).then((res) => {
                        if (res.status) {
                            this.emailDisabled = true
                            this.codeTimer = setInterval(function () {
                                if (vm.emailTime <= 0) {
                                    vm.emailTime = 180
                                    vm.emailDisabled = false
                                    clearInterval(vm.codeTimer)
                                } else {
                                    vm.emailTime--
                                }
                            }, 1000)
                        }
                    })
                }
            })
        },
        submitForm (name) {
            let params
            if (name === 'phoneForm') {
                params = {
                    phone: this.phoneForm.phone,
                    code: this.phoneForm.smsCode,
                    password: this.$encrypt(this.phoneForm.password, true)
                }
            } else {
                params = {
                    email: this.emailForm.email,
                    code: this.emailForm.emailCode,
                    password: this.$encrypt(this.emailForm.password, true)
                }
            }
            params.userType = 2
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.validateMsg = ''
                    this.showValidateMsg = false
                    this.axios.post(this.urlFormat(API.RESET_PASSWORD, true),
                        params,
                        {
                            headers: {
                                noAuth: true,
                                showMsg: false
                            }
                        })
                        .then(res => {
                            if (res.status) {
                                this.loading = false
                                this.isSuccess = true
                                setInterval(() => { this.second-- }, 1000)
                                setTimeout(() => { this.goLogin() }, this.second * 1000)
                            } else {
                                this.loading = false
                                this.validateMsg = res.message
                                this.showValidateMsg = true
                            }
                        }).catch(e => {
                            this.loading = false
                        })
                }
            })
        },
        // 手机号是否重复的异步校验
        async uniqueValidate (type, value) {
            const data = await this.axios.get(this.urlFormat(API.GET_USRTINF_VALIDATION, true), {
                params: {
                    validateType: type,
                    validateData: value
                },
                headers: {
                    noAuth: true
                }
            })
            return data
        },
        goLogin () {
            this.$login()
            // this.$router.push({ path: '/login' })
        },
        openUrl () {
            this.$router.push({ path: '/' })
        },
        handleCopy () {
            // 不允许复制
            return false
        }
    }
}
</script>
<style lang="less">
.retrieve-form-div {
    .ivu-tabs {
        color: #999;
        font-size: 16px;
        background: #fff;
        .ivu-tabs-bar {
            margin-bottom: 40px;
            .ivu-tabs-nav {
                width: 460px;
                .ivu-tabs-tab {
                    margin-right: 0;
                    width: 230px;
                    height: 60px;
                    line-height: 44px;
                    text-align: center;
                }
                .ivu-tabs-tab:hover {
                    color: #333;
                }
                .ivu-tabs-tab-active {
                    color: #333;
                }
                .ivu-tabs-ink-bar {
                    width: 230px;
                    // background-color: #0fa586;
                }
            }
        }
    }
}
</style>
<style lang="less" scoped>
#retrieve-psw-container {
    width: 100%;
    height: 100%;
    background-image: url(../assets/images/console/retrievePsdBg.png);
    background-size: cover;
    position: relative;
    .info {
        color: #ff7f27;
    }

    .syslogo-container {
        height: 46px;
        line-height: 46px;
        padding-left: 30px;
        padding-right: 30px;
        background: #2a303c;

        img {
            width: 160px;
            margin: 0;
            vertical-align: middle;
            cursor: pointer;
        }
        span {
            float: right;
            color: #fff;
            cursor: pointer;
        }
        a {
            float: right;
            color: #ffffff;
        }
    }
    .retrieve-form-div {
        width: 460px;
        height: 430px;
        position: absolute;
        left: 50%;
        top: 20%;
        transform: translateX(-50%);
        background: #fff;
        .form-container {
            margin: 0 auto;
            width: 330px;
            height: 335px;
            background: #fff;
            .code-btn {
                float: right;
                width: 45%;
                font-size: 12px;
            }
            .submit {
                font-size: 14px;
            }
        }
        .reser-pwd-formContent {
            position: absolute;
            padding-top: 45px;
            top: 50%;
            width: 100%;
            height: 300px;
            text-align: center;
            transform: translateY(-50%);
        }
    }
    .footer {
        position: absolute;
        bottom: 0px;
        width: 100%;
        line-height: 20px;
        font-size: 12px;
        color: #808080;
        text-align: center;
        padding: 30px 0;
        width: 1170px;
        margin-left: -585px;
        border-top: 1px solid #e3e3e3;
        left: 50%;
    }
    .np-retr {
        .title-np {
            display: block;
            text-align: center;
            margin-top: 10px;
        }
    }
}
</style>
